function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import { Box, TableList, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { Attachments } from "../../../../components/Attachments/Attachments";
import { emptyCell } from "../../../../constants";
import { utils } from "../../../../utils";
import { VendorLineItem, CustomerLineItem } from "./LineItem/LineItem";
import styles from "./ScheduledInvoice.module.scss";
import { columnDefs, HeaderDateIndicator } from "./ScheduledInvoice.utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const deprecatedTestIds = {
  ScheduledInvoiceTestIds: {
    Root: 'scheduled-invoice',
    IssueDate: 'scheduled-invoice-issue-date',
    DueOnDate: 'scheduled-invoice-due-on-date',
    RowsContainer: 'scheduled-invoice-rows-container',
    TotalAmountRow: 'total-amount-row'
  }
};
export const GetScheduledInvoiceTID = parentTestId => getTestIds({
  parentTestId,
  deprecatedTestIds
});
export default function ScheduledInvoice(props) {
  const {
    ScheduledInvoiceTestIds
  } = useMemo(() => GetScheduledInvoiceTID(), []);
  const ScheduledInvoiceTableRow = props.isVendor ? VendorLineItem : CustomerLineItem;
  return /*#__PURE__*/_jsx(TableList.Provider, {
    variant: "minimal",
    columnDefs: columnDefs,
    justifyBetween: true,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.root,
      "data-testid": ScheduledInvoiceTestIds.Root(),
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.infoRow,
        children: [/*#__PURE__*/_jsx(HeaderDateIndicator, {
          label: "Issue date",
          date: props.issueDate,
          testId: ScheduledInvoiceTestIds.IssueDate()
        }), /*#__PURE__*/_jsx(HeaderDateIndicator, {
          label: "Due on",
          date: props.paymentDate,
          testId: ScheduledInvoiceTestIds.DueOnDate()
        })]
      }), /*#__PURE__*/_jsx(TableList.Header, {
        className: styles.header,
        bgColor: "darkGray",
        items: columnDefs
      }), props.rowsProps.length ? /*#__PURE__*/_jsxs("div", {
        "data-testid": ScheduledInvoiceTestIds.RowsContainer(),
        children: [props.rowsProps.map(rowProps => /*#__PURE__*/_jsx(ScheduledInvoiceTableRow, _objectSpread(_objectSpread({}, rowProps), {}, {
          addedLineItemId: props.addedLineItemId
        }), rowProps.charge.id)), /*#__PURE__*/_jsx(TableList.Row, {
          className: styles.footerRow,
          items: [emptyCell, emptyCell, {
            value: /*#__PURE__*/_jsx(Typography, {
              variant: "paragraph1",
              children: "Subtotal"
            })
          }, emptyCell, {
            value: /*#__PURE__*/_jsx(Typography, {
              weight: "normal",
              children: utils.formatDollarAmount(props.totalAmount)
            })
          }, emptyCell, emptyCell],
          testId: ScheduledInvoiceTestIds.TotalAmountRow()
        }), props.attachments && props.isVendor && /*#__PURE__*/_jsx(Box, {
          className: styles.attachments,
          children: /*#__PURE__*/_jsx(Attachments, {
            disableDownloadLinks: true,
            files: props.attachments.files,
            onRemove: props.attachments.onRemove
          })
        })]
      }) : /*#__PURE__*/_jsxs(Typography, {
        variant: "paragraph1",
        className: styles.empty,
        children: ["Services included in your next invoice will appear here.", /*#__PURE__*/_jsx("br", {}), "You can add services by clicking on \"Billing Control\" at the top right."]
      })]
    })
  });
}